import type { BoardAdmins } from '@atlassian/jira-boards-common/src/model/index.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { EntityCellProps } from '../../../../model/index.tsx';
import { getAdministrators } from '../../../../state/selectors/boards/index.tsx';
import type { State } from '../../../../state/types.tsx';
import Administrators from './view.tsx';

type StateProps = BoardAdmins;

type OwnProps = EntityCellProps;

// @ts-expect-error - 2345 - Type 'undefined' is not assignable to type 'User[]'
const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => ({
	...getAdministrators(state, ownProps.id),
});

export default connect(mapStateToProps, {})(Administrators);
